import React from 'react';
import ArrowButton from "../../../common/button-arrow";

export default ({handleNew, downloadAll}) => (
  <div className="mg-bottom-60 mg-top-10">
    <div className="pull-left">
      <ArrowButton submit={false}
                   arrow={false}
                   onClick={handleNew}
                   permissions={{
                     action: "create",
                     subjectClass: "Group",
                   }}
                   className="pull-right"><i className="fa fa-plus"/> New group</ArrowButton>
    </div>
    <div className="pull-right">
      <ArrowButton submit={false}
                   arrow={false}
                   onClick={(event) => downloadAll()}
                   permissions={{
                     action: "handle",
                     subjectClass: "Group",
                   }}
                   className="pull-right">Download All</ArrowButton>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/admin/groups/list/groups-navigation-head.jsx